// English texts of the "mobile" area. Keys start with "mobile."
export default {
  // Top bar, sync status, bottom navigation, add button
  "mobile.shell.docProps": "Document properties: {title}",
  "mobile.shell.user": "user",
  "mobile.shell.notificationsCount": "Notifications ({n})",
  "mobile.shell.filters": "Filters",
  "mobile.shell.renderError": "Mobile view could not render.",
  "mobile.shell.loadingDocument": "Loading document",
  "mobile.mode.syncPaused": "Sync paused",
  "mobile.mode.viewOnly": "View only",
  "mobile.mode.mapFull": "Map full",
  "mobile.mode.syncing": "Syncing…",
  "mobile.nav.outline": "Outline",
  "mobile.nav.board": "Board",
  "mobile.nav.timeline": "Timeline",
  "mobile.fab.addNode": "Add node",
  "mobile.fab.newNote": "New note",
  "mobile.fab.addCard": "Add card",
  "mobile.fab.title": "{label} (long-press to add at root)",
  "mobile.empty.noDocument": "No document loaded",
  "mobile.fold.unfoldOne": "Unfold one level",
  "mobile.fold.foldFirst": "Fold to first level",
  "mobile.current": "Current",
  "mobile.restore": "Restore",
  "mobile.appearance": "Appearance",
  "mobile.nodes": "Nodes",

  // Vault (document list)
  "mobile.docs.currentDocument": "Current Document",
  "mobile.docs.mapCount_one": "{count} map",
  "mobile.docs.mapCount_other": "{count} maps",
  "mobile.docs.searchPlaceholder": "Search maps…",
  "mobile.docs.searchAria": "Search maps",
  "mobile.docs.folderPath": "Folder path",
  "mobile.docs.up": "Up",
  "mobile.docs.searchResults": "Search Results",
  "mobile.docs.documents": "Documents",
  "mobile.docs.empty": "No documents here",
  "mobile.docs.sharedWithMe": "Shared With Me",
  "mobile.docs.docActions": "Document actions",
  "mobile.docs.cannotRename": "Cannot rename this document because it is no longer editable here.",
  "mobile.docs.cannotDelete": "Cannot delete this document because it is no longer editable here.",
  "mobile.docs.cannotMove": "Cannot move this document because it is no longer editable here.",
  "mobile.docs.cannotChange": "Cannot change this document because it is no longer editable here.",
  "mobile.docActions.moveToFolder": "Move to folder",
  "mobile.docActions.duplicate": "Duplicate map + attachments",
  "mobile.docActions.export": "Export map…",
  "mobile.docActions.sharedHint": "Shared documents can be opened here, but ownership actions stay disabled on mobile.",
  "mobile.folderActions.newSubfolder": "New subfolder",

  // Share invitations
  "mobile.invite.pendingAria": "Pending share invitations",
  "mobile.invite.shareInvitations": "Share invitations",
  "mobile.invite.untitled": "Untitled document",
  "mobile.invite.someone": "someone",
  "mobile.invite.accepting": "Accepting…",
  "mobile.invite.accepted": "Invitation accepted",
  "mobile.invite.declineConfirm": "Decline this share invitation? The owner can invite you again later.",
  "mobile.invite.declined": "Invitation declined",
  "mobile.invite.declineFailed": "Couldn't decline the invitation: {error}",

  // Map and Bubbles tabs
  "mobile.map.emptyText": "Open a document to see its map.",
  "mobile.map.cycleLayoutAria": "Cycle layout: balanced, right, left",
  "mobile.map.cycleLayoutTitle": "Cycle layout (balanced / right / left)",
  "mobile.map.fitAria": "Fit all to view",
  "mobile.map.fitTitle": "Fit all",

  // Board tab
  "mobile.board.noDocText": "Open or create a document from Docs before using Board.",
  "mobile.board.noColumns": "No board columns",
  "mobile.board.noColumnsText": "Board columns come from status tags. Add mandatory status tags on desktop, then assign them to mobile cards.",
  "mobile.board.column": "Column",
  "mobile.board.columnCount": "{name} ({n})",
  "mobile.board.noCards": "No cards",
  "mobile.board.noCardsText": "Cards appear here when leaf nodes use this status.",
  "mobile.board.changeStatus": "Change status",
  "mobile.status.title": "Change Status",
  "mobile.status.none": "No statuses",

  // Timeline tab (Gantt). Zoom buttons: 1 week, 1 month, 1 year…
  "mobile.timeline.noDocText": "Open or create a document from Docs before using Timeline.",
  "mobile.timeline.shorterRows": "Shorter rows",
  "mobile.timeline.tallerRows": "Taller rows",
  "mobile.timeline.centerToday": "Center on today",
  "mobile.timeline.zoomWeeks": "{n}w",
  "mobile.timeline.zoomMonths": "{n}m",
  "mobile.timeline.zoomYears": "{n}y",
  "mobile.timeline.chart": "Gantt chart",
  "mobile.timeline.unscheduled": "Unscheduled — open task properties to set dates",

  // Node panel
  "mobile.node.status": "Status",
  "mobile.node.noTags": "No tags",
  "mobile.node.start": "Start",
  "mobile.node.end": "End",
  "mobile.node.plusWeek": "+1w",
  "mobile.node.setColor": "Set color {color}",
  "mobile.node.colorHint": "Color cascades to all child nodes.",
  "mobile.node.noNotes": "No notes",
  "mobile.node.statusTagsAria": "Status and tags",
  "mobile.node.execution": "Execution",
  "mobile.node.listAddTitle": "Add to the note's list",
  "mobile.node.listRemoveTitle": "Remove from the note's list",
  "mobile.node.list": "+ List",
  "mobile.node.listed": "✓ Listed",
  "mobile.node.planned": "Planned: {range}",
  "mobile.node.repeatRoutine": "↻ Repeat / routine",
  "mobile.node.addToRoutine": "Add to routine",
  "mobile.node.actions": "Node actions",
  "mobile.node.heading": "Node",
  "mobile.node.focus": "Focus",
  "mobile.node.move": "Move",
  "mobile.node.childCount_one": "{count} child",
  "mobile.node.childCount_other": "{count} children",
  "mobile.node.delete": "Delete node",
  "mobile.tag.filterBy": "Filter by {name}",

  // Outline tab
  "mobile.outline.createDocument": "Create Document",
  "mobile.outline.noMatch": "No matching nodes",
  "mobile.outline.empty": "No nodes",
  "mobile.outline.nodeFallback": "node",
  "mobile.outline.hasNotes": "Has notes",
  "mobile.outline.foldChildrenAria": "Collapse or expand children",
  "mobile.outline.foldChildrenTitle": "Collapse / expand children",

  // Notes tab
  "mobile.notes.noRelatedMatch": "No related notes match this search",
  "mobile.notes.noLinked": "No linked notes yet. Try including title matches.",
  "mobile.notes.noMatch": "No matching notes",
  "mobile.notes.empty": "No document notes",
  "mobile.notes.untitled": "Untitled note",
  "mobile.notes.editTitle": "Edit Note",
  "mobile.notes.attachPhotoAria": "Take a photo and attach it",
  "mobile.notes.photo": "Photo",
  "mobile.notes.attachFileAria": "Attach a file",
  "mobile.notes.file": "File",
  "mobile.notes.noContent": "No content",
  "mobile.notes.openMap": "Open map",

  // Task list of a note ("Today"). {branch} is the "Unsorted" node's name, {button} the "+ List" button.
  "mobile.today.overrun": "+{n}d",
  "mobile.today.workedTitle": "Worked on it in this note. Tap to clear these work marks.",
  "mobile.today.postpone": "Postpone…",
  "mobile.today.changeDate": "Change date…",
  "mobile.today.pin": "Pin: carry over automatically",
  "mobile.today.unpin": "Unpin",
  "mobile.today.emptyHint": "Use “{button}” on an existing task, or enter a new task name above (created under “{branch}”).",

  // Search sheet
  "mobile.search.placeholder": "Search nodes and notes...",
  "mobile.search.docNotes": "Document Notes",
  "mobile.search.enterTerm": "Enter a search term.",

  // Create / rename / add forms
  "mobile.form.newDocument": "New Document",
  "mobile.form.newFolder": "New Folder",
  "mobile.form.renameDocument": "Rename Document",
  "mobile.form.renameFolder": "Rename Folder",
  "mobile.form.renameNode": "Rename Node",
  "mobile.form.addNode": "Add Node",
  "mobile.form.parent": "Parent: {name}",
  "mobile.form.newNode": "New node",
  "mobile.form.newNodeTags": "New node tags",

  // Move sheets
  "mobile.move.title": "Move \"{name}\"",
  "mobile.move.hint": "Choose a new parent. The node will be placed at the bottom.",
  "mobile.move.suggested": "Suggested",
  "mobile.move.allNodes": "All Nodes",
  "mobile.move.folderHint": "Choose the destination folder.",
  "mobile.move.docRoot": "Document root",
  "mobile.move.currentFocus": "Current focus",
  "mobile.move.selected": "Selected node",
  "mobile.move.currentParent": "Current parent",

  // Confirmation dialogs
  "mobile.confirm.sure": "Are you sure?",
  "mobile.confirm.discard": "Discard",
  "mobile.confirm.discardTitle": "Discard changes?",
  "mobile.confirm.discardNode": "Close this node editor without saving your changes?",
  "mobile.confirm.discardNote": "Close this note editor without saving your changes?",
  "mobile.confirm.recoverNodeTitle": "Recover unsaved node edit?",
  "mobile.confirm.recoverNoteTitle": "Recover unsaved note?",
  "mobile.confirm.recoverMessage": "An earlier edit was kept after the document was switched. Restore it now? (Cancel keeps the saved version.)",
  "mobile.confirm.deleteNoteTitle": "Delete Note",
  "mobile.confirm.deleteNote": "Delete this document note? This cannot be undone.",
  "mobile.confirm.deleteNodeTitle": "Delete Node",
  "mobile.confirm.deleteNode": "Delete \"{name}\" and all of its children?",
  "mobile.confirm.thisNode": "this node",
  "mobile.confirm.deleteDocTitle": "Delete Document",
  "mobile.confirm.deleteDoc": "Delete \"{name}\"? This cannot be undone.",
  "mobile.confirm.thisDocument": "this document",
  "mobile.confirm.deleteFolderTitle": "Delete Folder",
  "mobile.confirm.deleteFolder": "Delete \"{name}\"?",
  "mobile.confirm.deleteFolderMove": "Delete \"{name}\"? Contents will be moved to {parent}.",
  "mobile.confirm.thisFolder": "this folder",
  "mobile.confirm.rootFolder": "the root folder",
  "mobile.confirm.removeUserTitle": "Remove user?",
  "mobile.confirm.removeUser": "Remove {name} from the share? Their access key is rotated away; they get a snapshot to recover a local copy.",
  "mobile.confirm.thisUser": "this user",
  "mobile.confirm.restoreAccessTitle": "Restore access?",
  "mobile.confirm.restoreAccess": "{name} re-registered their encryption key. Restore their access to this map with the new key?",
  "mobile.confirm.stopSharingTitle": "Stop sharing?",
  "mobile.confirm.stopSharing": "Revoke access for every member? Each gets a snapshot to recover a local copy.",
  "mobile.confirm.logout": "Sign out and return to the login screen?",
  "mobile.confirm.recovery": "Generate a new 12-word recovery phrase? Your current phrase (if any) stops working. Your password and data are unaffected. You'll be shown the new phrase to write down.",

  // Tag filter sheet
  "mobile.filter.dimStrength": "Highlight dim strength",

  // Account sheet
  "mobile.account.user": "User",
  "mobile.account.status": "Signed in · syncing enabled",
  "mobile.account.install": "Install app",
  "mobile.account.installHint": "Add Orbital to your home screen",
  "mobile.account.recoveryPhrase": "Recovery phrase",
  "mobile.account.recoveryHint": "Generate a new 12-word phrase",
  "mobile.account.delete": "Delete account",
  "mobile.account.recoveryFailed": "Couldn't update the recovery phrase: {error}",
  "mobile.theme.nord": "Nord",

  // Document properties sheet and sharing
  "mobile.docProps.document": "Document",
  "mobile.docProps.docNotes": "Doc Notes",
  "mobile.docProps.thisDocument": "This document",
  "mobile.docProps.tagFilters": "Tag filters",
  "mobile.docProps.activeFilters_one": "{count} active",
  "mobile.docProps.activeFilters_other": "{count} active",
  "mobile.docProps.noneActive": "None active",
  "mobile.docProps.access": "Access",
  "mobile.docProps.editable": "Editable",
  "mobile.share.loading": "Loading sharing info…",
  "mobile.share.private": "Private",
  "mobile.share.notShared": "Not shared with anyone",
  "mobile.share.ownerYou": "Owner (you)",
  "mobile.share.role": "Role",
  "mobile.share.thisUser": "This user",
  "mobile.share.removeAria": "Remove {name}",
  "mobile.share.invitedPending": "Invited · {role} · pending",
  "mobile.share.yourRole": "Your role: {role}",
  "mobile.share.invitePlaceholder": "Username to invite",
  "mobile.share.inviteRole": "Role for the invitee",
  "mobile.share.invite": "Invite",
  "mobile.share.stopHint": "Revoke access for every member",

  // Notifications sheet
  "mobile.notifications.empty": "No notifications",
  "mobile.notifications.generic": "Notification",
  "mobile.notifications.recovering": "Recovering…",

  // Error notices: "{message}: {detail}", where the detail is the error's own text
  "mobile.error.detail": "{message}: {detail}",
  "mobile.error.renameNode": "Could not rename node",
  "mobile.error.sendInvitation": "Could not send the invitation",
  "mobile.error.changeRole": "Could not change the role",
  "mobile.error.removeUser": "Could not remove the user",
  "mobile.error.cancelInvitation": "Could not cancel the invitation",
  "mobile.error.restoreAccess": "Could not restore access",
  "mobile.error.stopSharing": "Could not stop sharing",
  "mobile.error.recoveryFailed": "Recovery failed",
  "mobile.error.recoverDocument": "Could not recover the document — try again.",
  "mobile.error.dismissNotification": "Could not dismiss the notification",
  "mobile.error.openRefDoc": "Could not open referenced document",
  "mobile.error.saveNodeKept": "Could not save node — kept locally",
  "mobile.error.toggleCollapse": "Could not toggle collapse",
  "mobile.error.addNode": "Could not add node",
  "mobile.error.cannotCreateNote": "Cannot create note",
  "mobile.error.createNote": "Could not create note",
  "mobile.error.removeEmptyNote": "Could not remove empty note",
  "mobile.error.saveNoteKept": "Could not save note — kept locally",
  "mobile.error.actionFailed": "Action failed",
  "mobile.error.deleteNote": "Could not delete note",
  "mobile.error.deleteNode": "Could not delete node",
  "mobile.error.moveNode": "Could not move node",
  "mobile.error.updateCollapsed": "Could not update collapsed nodes",
  "mobile.error.expandNodes": "Could not expand nodes",
  "mobile.error.collapseNodes": "Could not collapse nodes",
  "mobile.error.updateTag": "Could not update tag",
  "mobile.error.changeStatus": "Could not change status",
  "mobile.error.openDoc": "Could not open document",
  "mobile.error.createDoc": "Could not create document",
  "mobile.error.createFolder": "Could not create folder",
  "mobile.error.renameDoc": "Could not rename document",
  "mobile.error.renameFolder": "Could not rename folder",
  "mobile.error.deleteFolder": "Could not delete folder",
  "mobile.error.moveDoc": "Could not move document",

  // Notices (toasts)
  "mobile.toast.renameKeptDocGone": "Rename kept locally — original document is no longer loaded.",
  "mobile.toast.renameKeptNodeGone": "Rename kept locally — node is no longer available.",
  "mobile.toast.finishRename": "Finish the rename before changing views.",
  "mobile.toast.finishNoteEdit": "Finish or discard the note edit before leaving.",
  "mobile.toast.finishNodeEdit": "Finish or discard the node edit before leaving.",
  "mobile.toast.noteEditClosed": "Note edit closed — note is no longer available.",
  "mobile.toast.refDocUnavailable": "Referenced document is not available.",
  "mobile.toast.refNodeNotInDoc": "Referenced node is not available in this document.",
  "mobile.toast.refNodeUnavailable": "Referenced node is not available.",
  "mobile.toast.nodeSaveKept": "Node save cancelled — edit kept locally because the document changed.",
  "mobile.toast.nodeSaveCancelled": "Node save cancelled — document changed since editing started.",
  "mobile.toast.nodeEditKeptNodeGone": "Node edit kept locally — node is no longer available.",
  "mobile.toast.nodeEditKeptDocGone": "Node edit kept locally — original document is no longer loaded.",
  "mobile.toast.nodeNotAdded": "Node was not added. Check that this document is editable.",
  "mobile.toast.returnToAdd": "Return to the original document to add this node.",
  "mobile.toast.nodeUnavailable": "Node is no longer available.",
  "mobile.toast.noteSaveKept": "Note save cancelled — edit kept locally because the document changed.",
  "mobile.toast.noteSaveCancelled": "Note save cancelled — document changed since editing started.",
  "mobile.toast.noteEditKeptDocGone": "Note edit kept locally — original document is no longer loaded.",
  "mobile.toast.noteUnavailable": "Note is no longer available.",
  "mobile.toast.noteNotDeleted": "Note was not deleted because it changed.",
  "mobile.toast.nodeNotDeleted": "Node was not deleted. Check that this document is editable.",
  "mobile.toast.nodeNotMoved": "Node was not moved. Check that this document is editable.",
  "mobile.toast.rootFolder": "The root folder cannot be deleted.",
  "mobile.toast.folderUnavailable": "Folder is no longer available.",
  "mobile.stash.privacyNode": "For privacy, node edit kept in memory only. Return to the document before refreshing.",
  "mobile.stash.privacyNote": "For privacy, note edit kept in memory only. Return to the document before refreshing.",
  "mobile.stash.fullNode": "Storage full — node edit kept in memory only. Refresh will lose it.",
  "mobile.stash.fullNote": "Storage full — note edit kept in memory only. Refresh will lose it.",

  // Attachments (photo / file in a note)
  "mobile.attach.openNote": "Open a note before attaching a file.",
  "mobile.attach.noKey": "Can't attach right now — this document's encryption key isn't available.",
  "mobile.attach.uploadingFile": "Uploading {name}…",
  "mobile.attach.added_one": "Attachment added",
  "mobile.attach.added_other": "{count} attachments added",
  "mobile.attach.noNote": "Uploaded, but no open note to insert into.",
};
